import { apiFetch } from '@/lib/api-client';

// « Rythme de validation » (user ask 2026-08-03) — admin-only piloting figures.
// Two endpoints on purpose: the queue banner loads the cheap `progress` one on every visit, the
// Statistics page loads the full report. Both are SYSTEM_ADMIN-gated server-side.

export type StatsPeriod = '7d' | '30d' | 'month' | 'all';

export interface ValidationProgress {
  /** Dossiers with a FINAL verdict (Validated or Rejected — escalations/Build are still in progress). */
  treated: number;
  /** Every real Uniticket ADDRESS_MANAGEMENT ticket known locally. */
  total: number;
  open: number;
  pct: number;
  weekToDate: number;
  monthToDate: number;
}

export interface StatsBucket {
  bucket: string; // YYYY-MM-DD — the day, or the Monday of the week
  validated: number;
  rejected: number;
  escalated: number;
  sentToBuild: number;
  created: number;
}

export interface ReviewerStat {
  userId: string | null;
  name: string;
  validated: number;
  rejected: number;
  escalated: number;
  sentToBuild: number;
  treated: number;
}

export interface ValidationReport {
  period: StatsPeriod;
  bucket: 'day' | 'week';
  from: string;
  today: string;
  totals: {
    treated: number;
    validated: number;
    rejected: number;
    escalated: number;
    sentToBuild: number;
    created: number;
  };
  queue: { pending: number; escalated: number; waitingBuild: number; noJvid: number };
  leadTime: { count: number; avgDays: number | null; medianDays: number | null };
  progress: ValidationProgress;
  series: StatsBucket[];
  byReviewer: ReviewerStat[];
}

export function fetchValidationProgress(): Promise<{ data: ValidationProgress }> {
  return apiFetch<{ data: ValidationProgress }>('/admin/validation-progress');
}

export function fetchValidationReport(period: StatsPeriod): Promise<{ data: ValidationReport }> {
  return apiFetch<{ data: ValidationReport }>(`/admin/validation-report?period=${period}`);
}
